import { Box, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

const Container = styled(Box).attrs({
  contain: true,
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1.24",
  mb: 7,
  mt: 4,
  mx: { _: 2, tablet: "auto" },
})`
  b {
    font-weight: 600;
  }

  a {
    text-decoration: underline;

    &:focus,
    &:hover {
      text-decoration: none;
    }
  }
`

const Paragraph = styled(Typography).attrs((props) => ({
  mb: 2,
  ...props,
}))``

const PrivacyPolicy = () => (
  <Container>
    <Typography
      as="h1"
      fontSize={{ _: "26px", tablet: "34px" }}
      fontWeight="400"
      letterSpacing="-0.02em"
      lineHeight="48px"
      mb="10px"
    >
      Privacy Policy
    </Typography>
    <Paragraph>
      Safyre Labs has improved our Terms and Conditions and Privacy Policy to
      make it easier for you to understand what data we collect and what
      it&apos;s used for.
    </Paragraph>
    <Paragraph fontWeight="600">We Care About Your Privacy</Paragraph>
    <Paragraph>
      Your privacy is important to Safyre Labs, so we have created the following
      Privacy Policy to let you know what information we collect when you visit
      our website, Safyre Labs (the &quot;Site&quot;), why we collect it, and
      how it is used. This Privacy Policy also addresses our data security
      practices, the options you have to access and control any personally
      identifiable information you provide to us, and other matters. We may
      periodically make changes to this Privacy Policy which will be included on
      this page. It is your responsibility to review this Privacy Policy
      frequently and remain informed about any changes to it, so we encourage
      you to visit this page often. By using the Site, you agree to this Privacy
      Policy. This is our entire and exclusive Privacy Policy and it supersedes
      any earlier version.
    </Paragraph>
    <Paragraph fontWeight="600">Email</Paragraph>
    <Paragraph>
      When you give us your email address, or send us email correspondence, we
      retain your email address. We do not share our email lists with third
      parties for marketing purposes. We use email addresses to communicate with
      you regarding your orders and other matters regarding transactions between
      us or your customer relationship with us. We retain information provided
      by all of our customers, such as registration information, transaction
      information (e.g., dates on which customers made purchases, amounts and
      types of purchases) and contact information (e.g., name, address, phone
      number).
    </Paragraph>
    <Paragraph fontWeight="600">Security</Paragraph>
    <Paragraph>
      Safyre Labs takes every precaution to protect our users&apos; information.
      When users submit sensitive information via our website, your information
      is protected both online and off-line. We use industry-standard encryption
      technologies when transferring and receiving customer data exchanged with
      our website server. Information entered into the registration or order
      form is considered sensitive information (such as credit card number
      and/or address) and that information is encrypted and is protected with
      the best encryption software in the industry. In addition, the servers
      where we store personally identifiable information are kept in a secure
      environment under restricted access.
    </Paragraph>
    <Paragraph fontWeight="600">Information Collection And Use</Paragraph>
    <Paragraph>
      Safyre Labs is the sole owner of the information collected on this site.
      We will not sell, share, or rent this information to others in ways
      different from what is disclosed in this statement. Safyre Labs collects
      information from our users at several different points on our website.
    </Paragraph>
    <Paragraph>
      In addition, subject to applicable law, you have the right to request
      access to, correct, and delete your personal data, and to ask for data
      portability. You may also object to our processing of your personal data
      or ask that we restrict the processing of your personal data in certain
      instances. If you wish to do any of these things, please contact us at{" "}
      <Typography as="a" href="mailto:privacy@safyrelabs.com" rel="nofollow">
        privacy@safyrelabs.com
      </Typography>
      .
    </Paragraph>
    <Paragraph fontWeight="600">Usage Tracking</Paragraph>
    <Paragraph>
      Safyre Labs tracks the traffic throughout our site. This information is
      used to compile overall statistics and is not recorded at an individual
      level. This includes IP (internet protocol) addresses, browser type, ISP
      (internet service provider), referring/exit pages, platform type,
      date/time stamp, and # of clicks to analyze trends, administer the site,
      track user&apos;s movement in the aggregate. These statistics help us
      decide which products and services best serve our members and guests.
    </Paragraph>
    <Paragraph fontWeight="600">Cookies</Paragraph>
    <Paragraph>
      A cookie is a piece of data stored on the user&apos;s hard drive
      containing information about the user. We use both session and persistent
      cookies. Usage of a cookie from our site is in no way linked to any
      personally identifiable information. Cookies enable us to track and target
      the interests of our users in the aggregate by analyzing popular areas and
      products to enhance future experiences on our site. Cookies do not cause
      damage to your computer systems or files, and only the web site that
      transferred a particular cookie to you can read, modify or delete such
      cookie. If you do not want information collected through the use of
      cookies, there are simple procedures in most browsers that allow you to
      delete existing cookies, to automatically decline cookies, or to be given
      the choice of declining or accepting the transfer of particular cookies to
      your computer.
    </Paragraph>
  </Container>
)

export default PrivacyPolicy
